import type { CityConfig } from "../city-template/types";

export const bakersfieldConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Bakersfield",
  state: "California",
  stateAbbr: "CA",
  slug: "bakersfield",
  route: "/bakersfield",
  title: "Emergency Passport Bakersfield, CA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Bakersfield, CA — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Kern County travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Bakersfield, CA",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Bakersfield and Kern County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Bakersfield%20California%20downtown%20cityscape%20at%20golden%20hour%20with%20modern%20high-rise%20buildings%20and%20historic%20Kern%20County%20courthouse%2C%20warm%20Central%20Valley%20sunset%20light%2C%20agricultural%20landscape%20visible%20in%20the%20distance%2C%20clean%20modern%20urban%20skyline%2C%20professional%20cityscape%20photography%2C%20wide%20panoramic%20view%2C%20no%20visible%20text%20or%20people%2C%20vibrant%20Southern%20San%20Joaquin%20Valley%20scene&width=1800&height=700&seq=bakersfield-hero-001&orientation=landscape",
  heroImageAlt: "Bakersfield California skyline at golden hour with downtown buildings and Kern County landscape",
  geoPosition: "35.3733;-119.0187",
  geoPlacename: "Bakersfield, California",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Los Angeles Passport Agency",
    address: "11000 Wilshire Blvd Suite 1000, Los Angeles, CA 90024",
    distance: "Located in downtown LA — approximately 2 hours from Bakersfield via I-5",
  },
  nearbyCitiesZips: [
    { name: "Bakersfield", zips: "93301–93309, 93311, 93312, 93313, 93314, 93380, 93383, 93384, 93385, 93386, 93387, 93388, 93389, 93390" },
    { name: "Oildale", zips: "93308, 93308" },
    { name: "Delano", zips: "93215, 93216" },
    { name: "Wasco", zips: "93280" },
    { name: "Shafter", zips: "93263" },
    { name: "Arvin", zips: "93203" },
    { name: "Tehachapi", zips: "93561" },
    { name: "California City", zips: "93505" },
    { name: "Ridgecrest", zips: "93555, 93556" },
    { name: "Lamont", zips: "93241" },
    { name: "Taft", zips: "93268" },
    { name: "McFarland", zips: "93250" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Kern County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Los Angeles", route: "/los-angeles" },
    { name: "Fast passport renewal in San Diego", route: "/san-diego" },
    { name: "Emergency passport help in San Francisco", route: "/san-francisco" },
    { name: "Urgent passport services in San Jose", route: "/san-jose" },
    { name: "Same-day passport help in Sacramento", route: "/sacramento" },
    { name: "Passport courier services near Fresno", route: "/fresno" },
    { name: "Rush passport help in Long Beach", route: "/long-beach" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Bakersfield remotely via secure courier. We do not have a walk-in office in Bakersfield — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Kern County travelers.",
  fpcOfficeAddress: "200 Spectrum Center Dr, Irvine, CA 92618",
  fpcOfficeDistance: "Serving all of Kern County",
  serviceAreaIntro: "From downtown Bakersfield to the Oildale area, from the west side to the east side — Fast Passport Center serves the entire Bakersfield community and surrounding Kern County. We regularly help travelers from Delano, Wasco, Shafter, and Tehachapi get their passports fast.",
  nearbyCitiesIntro: "We serve all Bakersfield neighborhoods and nearby Kern County cities including Delano, Wasco, Shafter, Arvin, Tehachapi, California City, Ridgecrest, and Taft. If you are in Kern County or the Southern San Joaquin Valley, we have you covered.",
  howItWorksIntro: "Most Bakersfield travelers complete everything online and ship documents overnight. No need to drive to Los Angeles or wait in line at the regional agency.",
  mistakesIntro: "Bakersfield travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Bakersfield and Kern County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Bakersfield? Here are the most common ones we hear from Kern County travelers.",
  statePageRoute: "/states/california",
  statePageName: "California",
  dmvWebsite: "https://www.dmv.ca.gov",
  dmvLabel: "California DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Kern County international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Robert M.",
      location: "Bakersfield, CA",
      rating: 5,
      text: "My business trip to Canada was in 3 days and my passport was expired. Fast Passport Center got me a new one in 36 hours. Saved an important client meeting.",
      service: "Emergency Passport",
    },
    {
      name: "Angela T.",
      location: "Delano, CA",
      rating: 5,
      text: "Needed to renew my passport for a family visit to the Philippines. The process was smooth, they reviewed my documents, and I had my passport in 4 days.",
      service: "Passport Renewal",
    },
    {
      name: "Chris L.",
      location: "Wasco, CA",
      rating: 5,
      text: "Lost my passport the week before my cruise to Mexico. They walked me through the DS-64 process and got me a replacement in 2 days. Incredible service.",
      service: "Lost Passport",
    },
    {
      name: "Patricia H.",
      location: "Tehachapi, CA",
      rating: 5,
      text: "Living in the mountains, I thought getting an expedited passport would be impossible. Fast Passport Center made it easy with overnight shipping. Professional and reliable.",
      service: "Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "bakersfield-1",
      name: "Bakersfield Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2825 F St",
      city: "Bakersfield",
      state: "CA",
      zip: "93301",
      phone: "(661) 324-3211",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.3 miles from downtown Bakersfield",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major facility for Kern County. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "bakersfield-2",
      name: "Bakersfield Southwest Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "9000 Rosedale Hwy",
      city: "Bakersfield",
      state: "CA",
      zip: "93312",
      phone: "(661) 588-3834",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "2.5 miles from the Marketplace",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Busy location — book appointments 2+ weeks in advance. Limited weekend hours.",
      icon: "ri-mail-line",
    },
    {
      id: "bakersfield-3",
      name: "Delano Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "900 Dover Pl",
      city: "Delano",
      state: "CA",
      zip: "93215",
      phone: "(661) 725-2151",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from downtown Delano",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves northern Kern County. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "bakersfield-4",
      name: "Ridgecrest Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 S Downs St",
      city: "Ridgecrest",
      state: "CA",
      zip: "93555",
      phone: "(760) 375-1361",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.3 miles from downtown Ridgecrest",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for eastern Kern County and high desert residents. Photo services available. Book ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "bakersfield-5",
      name: "Tehachapi Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "320 S Green St",
      city: "Tehachapi",
      state: "CA",
      zip: "93561",
      phone: "(661) 822-4432",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from downtown Tehachapi",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for mountain community residents. Limited passport hours — call to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "bakersfield-6",
      name: "Kern County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "1115 Truxtun Ave",
      city: "Bakersfield",
      state: "CA",
      zip: "93301",
      phone: "(661) 868-3590",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "0.2 miles from Bakersfield City Hall",
      website: "https://www.kerncounty.com/",
      websiteLabel: "Kern County Clerk",
      notes: "Major county facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 2 hour drive to LA", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Kern County Oil & Ag Industry", agency: "No special handling", fpc: "Yes — energy and agriculture travel document coordination" },
    { feature: "Southern Valley Coverage", agency: "Bakersfield only — visit in person", fpc: "Yes — serve Delano, Wasco, Shafter, Tehachapi" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Kern County photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Kern County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Bakersfield applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the LA regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Kern County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Kern County travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Bakersfield." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Bakersfield address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Bakersfield before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Bakersfield for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 2 hour drive to Los Angeles." },
    { q: "How fast can I renew my passport in Bakersfield?", a: "Fast Passport Center offers fast passport renewal in Bakersfield in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What if my passport expires before my cruise?", a: "If your passport expires before your cruise, contact Fast Passport Center immediately. Many cruise lines require your passport to be valid for at least 6 months beyond your travel date. We can expedite your passport renewal in Bakersfield in 24–48 hours so you don't miss your departure." },
    { q: "Can I get a same-day passport appointment near Bakersfield?", a: "Same-day passport appointments are only available at the LA Regional Passport Agency — a 2 hour drive from Bakersfield — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Kern County residents." },
    { q: "Can I expedite a child passport in Bakersfield?", a: "Yes. Fast Passport Center expedites child passports in Bakersfield for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Kern County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Bakersfield with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    {
      q: "How fast can I get a passport in Bakersfield?",
      a: "With Fast Passport Center's emergency courier service, Bakersfield travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays.",
    },
    {
      q: "Do I need to drive to the Los Angeles Passport Agency?",
      a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change.",
    },
    {
      q: "Where are the closest passport acceptance facilities in Bakersfield?",
      a: "Popular options include the Bakersfield Main Post Office (93301), Bakersfield Southwest Post Office (93312), Delano Post Office (93215), and Kern County Clerk (93301). All require appointments. We help you find the most convenient location and schedule your visit.",
    },
    {
      q: "Can I get a same-day passport in Bakersfield?",
      a: "Same-day passports are only available at the LA Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option — without the 2 hour drive to LA.",
    },
    {
      q: "What if I live in a smaller Kern County town?",
      a: "We serve the entire Kern County including Delano, Wasco, Shafter, Arvin, Tehachapi, California City, Ridgecrest, Lamont, and Taft. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed.",
    },
    {
      q: "How much does expedited passport service cost in Bakersfield?",
      a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline.",
    },
    {
      q: "Do you help with passport photos in Bakersfield?",
      a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and FedEx locations in Bakersfield and Delano offer passport photo services. We review your photos before submission to ensure they meet State Department standards.",
    },
    {
      q: "What documents do I need for a first-time passport in Bakersfield?",
      a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk.",
    },
    {
      q: "Can you help with a child's passport in Bakersfield?",
      a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Kern County families through the entire process and help schedule acceptance clerk appointments.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Bakersfield", address: "4725 Coffee Rd, Bakersfield, CA 93308", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Bakersfield", address: "2699 Mount Vernon Ave, Bakersfield, CA 93306", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "FedEx Office — Bakersfield", address: "4301 California Ave, Bakersfield, CA 93309", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
    { name: "UPS Store — Bakersfield", address: "8200 Stockdale Hwy, Bakersfield, CA 93311", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "Walmart — Delano", address: "530 Woollomes Ave, Delano, CA 93215", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "Rite Aid — Bakersfield", address: "3500 Stine Rd, Bakersfield, CA 93309", hours: "Mon–Sun: 8AM–10PM", website: "https://www.riteaid.com/" },
    { name: "Postal Annex — Bakersfield", address: "5025 California Ave, Bakersfield, CA 93309", hours: "Mon–Fri: 9AM–6PM, Sat: 9AM–4PM", website: "https://www.postalannex.com/" },
    { name: "Costco — Bakersfield", address: "3800 Rosedale Hwy, Bakersfield, CA 93308", hours: "Mon–Fri: 10AM–8:30PM, Sat–Sun: 9:30AM–6PM", website: "https://www.costco.com/" },
  ],
  dmvLocations: [
    {
      name: "DMV — Bakersfield",
      address: "3120 F St, Bakersfield, CA 93301",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and driver's license renewals. Appointment required.",
      featured: true,
    },
    {
      name: "DMV — Bakersfield SW",
      address: "7000 Schirra Ct, Bakersfield, CA 93313",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Passport-ready photo services available. Online appointment booking.",
      featured: false,
    },
    {
      name: "DMV — Delano",
      address: "920 Dover Pl, Delano, CA 93215",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID processing. Walk-ins limited — book online first.",
      featured: false,
    },
    {
      name: "DMV — Ridgecrest",
      address: "127 E California Ave, Ridgecrest, CA 93555",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Full-service center for eastern Kern County and high desert residents.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "BFL",
      name: "Meadows Field (Bakersfield)",
      distance: "8 miles from downtown Bakersfield",
      address: "3701 Wings Way, Bakersfield, CA 93308",
      note: "The primary airport for Kern County. Domestic flights with connections to major international hubs. Closest regional airport for Southern San Joaquin Valley.",
      flightUrl: "https://www.meadowsfield.com/",
      flightLabel: "Meadows Field Airport",
      featured: true,
    },
    {
      code: "LAX",
      name: "Los Angeles International Airport",
      distance: "110 miles from Bakersfield",
      address: "1 World Way, Los Angeles, CA 90045",
      note: "Major international hub for long-haul flights to Asia, Europe, and South America. Accessible via I-5.",
      flightUrl: "https://www.flylax.com/",
      flightLabel: "LAX Flight Info",
      featured: false,
    },
    {
      code: "FAT",
      name: "Fresno Yosemite International Airport",
      distance: "110 miles from Bakersfield",
      address: "5175 E Clinton Way, Fresno, CA 93727",
      note: "Alternative Central Valley airport with international flights to Mexico.",
      flightUrl: "https://www.fresno.gov/departments/airport/",
      flightLabel: "Fresno Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from the California Department of Public Health Vital Records. Online, mail, or in-person options available for Kern County residents.", url: "https://www.cdph.ca.gov/Programs/CHSI/Pages/Vital-Records.aspx" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through California CDPH Vital Records. Required for estate and legal matters in the Bakersfield area.", url: "https://www.cdph.ca.gov/Programs/CHSI/Pages/Vital-Records.aspx" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Kern County Clerk. Certified copies available for name changes and legal purposes in Bakersfield.", url: "https://www.kerncounty.com/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Kern County Superior Court. Required for name change passport corrections and legal documentation.", url: "https://www.kern.courts.ca.gov/" },
  ],
};